// @flow

import * as React from 'react'
import { Col, config, Container, Row, Hidden } from 'react-awesome-styled-grid'
import { FadeInImage } from '@components/shared/FadeInImage'
import {
  colors,
  DipseaContentfulAssets,
  OutlineOnFocusVisible,
  P,
  SectionHeader,
  SectionTitle
} from '@components/shared'
import styled from 'styled-components'

export default function OurPeople (): React.Node {
  return (
    <ContainerDiv className="container" id="our-people">
      <Container fluid={true}>
        <Row
          justify={{ sm: 'center', xl: 'flex-start' }}
          align={{ sm: 'center', md: 'center', lg: 'flex-start' }}
          className="our-people-row-wrapper"
        >
          <Col sm={8} md={8} lg={5}>
            <OurPeopleTitle>WHO WE ARE</OurPeopleTitle>
            <OurPeopleSubtitle>
              We are a women-led team
            </OurPeopleSubtitle>
          </Col>
          <Col sm={8} md={8} lg={7} xl={7}>
            <OurPeopleSpacer>
              <Text>
                We're a women-led team of producers and engineers who are obsessed with making the very best audio romance. We partner with an incredible network of top-tier narrators and writers to guarantee quality of every single story.
              </Text>
            </OurPeopleSpacer>
            <OurPeopleLinks>
              <div>
                <AnchorText>
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://angel.co/company/dipsea/jobs"
                  >
                    WORK WITH US
                  </a>
                </AnchorText>
              </div>
              <div>
                <AnchorText>
                  <a href="/voice">VOICE ACT FOR US</a>
                </AnchorText>
              </div>
            </OurPeopleLinks>
          </Col>
        </Row>
      </Container>
      <OurPeopleImgContainer>
        <Hidden xs={true} sm={true} md={false} lg={false} xl={false}>
          <FadeInImage src={DipseaContentfulAssets['About-Us-Scrolling-Image-v4.png']} width={4819} height={1566} />
        </Hidden>
        <Hidden xs={false} sm={false} md={true} lg={true} xl={true}>
          <FadeInImage src={DipseaContentfulAssets['About-Us-Mobile.png']} width={1125} height={806} />
        </Hidden>
      </OurPeopleImgContainer>
    </ContainerDiv>
  )
}

const ContainerDiv = styled.div`
  overflow: hidden;
  padding-top: 70px;
  ${(props: any): string => config(props).media.md`
    padding-top: 100px;
  `}
  ${(props: any): string => config(props).media.lg`
    padding-top: 119px;
  `}
  
  &.our-beliefs {
    ${(props: any): string => config(props).media.md`
      padding-top: 82px;
    `}
    ${(props: any): string => config(props).media.lg`
      padding-top: 120px;
    `}
    ${(props: any): string => config(props).media.xl`
      padding: 120px 80px 0;
    `}
  }

  &#our-people {
    padding: 59px 0 10px;
    ${(props: any): string => config(props).media.md`
       padding: 78px 0 20px;
    `}
    ${(props: any): string => config(props).media.lg`
       padding: 110px 0  40px;
      .our-people-row-wrapper {
        > div:last-child {
          padding: 0 30px 0 16px;
        }
      }
    `}
    ${(props: any): string => config(props).media.xl`
      > div:first-child {
        max-width: 1212px;
        margin: 0 auto;
      }
      .our-people-row-wrapper {
        > div:last-child {
          padding: 0 30px 0 116px;
        }
      }
    `}
    background-color: ${colors.midnightBlue};
  }
  &.our-people {
    background: linear-gradient(rgb(38 18 47 / 0%) 40%,${colors.midnightBlue} 60%);
    ${(props: any): string => config(props).media.sm`
      background: linear-gradient(rgb(38 18 47 / 0%), ${colors.midnightBlue} 50%);
    `}
    ${(props: any): string => config(props).media.md`
      background: linear-gradient(rgb(38 18 47 / 0%) 50%, ${colors.midnightBlue});
    `}
  }
  &.our-process {
    background-color: ${colors.sand};
    padding-bottom: 60px;
    overflow: hidden;
    ${(props: any): string => config(props).media.md`
      padding-top: 80px;
      padding-bottom: 130px;
    `}
    ${(props: any): string => config(props).media.lg`
      padding-top: 120px;
      padding-bottom: 110px;
    `}
  }
`
const OurPeopleSpacer = styled.div`
  margin-bottom: 25px;
  padding: 0;
  ${(props: any): string => config(props).media.lg`
    margin-top: 50px;
  `}
`
const OurPeopleLinks = styled.div`
  display: flex;
  flex-direction: column;
  ${(props: any): string => config(props).media.md`
    flex-direction: row;
    div {
      margin-right: 13px;
    }
  `}
  ${(props: any): string => config(props).media.lg`
    div {
      margin-right: 28px;
    }
  `}
`
const OurPeopleImgContainer = styled.div`
  margin-top: 0px;
  width: 100%;

  ${(props: any): string => config(props).media.md`
      margin-top: 45px;
      width: 100%;
    `}
  > div {
    ${(props: any): string => config(props).media.md`
      width: 100%;
    `}
    ${(props: any): string => config(props).media.lg`
      width: 100%;
    `}
  }
`

const OurPeopleSubtitle = styled(SectionHeader)`
  ${(props: any): string => config(props).media.md`
    font-size: 36px;
    line-height: 40px;
    margin-bottom: 20px;
  `}
  ${(props: any): string => config(props).media.lg`
    font-size: 60px;
    line-height: 66px;
    margin-bottom: 0px;
  `}
`
const OurPeopleTitle = styled(SectionTitle)`
  ${(props: any): string => config(props).media.md`
    margin-bottom: 20px;
  `}
  ${(props: any): string => config(props).media.lg`
    margin-bottom: 25px;
  `}
`

const AnchorText = styled(P)`
  font-size: 12px;
  line-height: 14.4px;
  color: ${colors.sand};
  text-decoration: underline;
  margin-bottom: 15px;
  letter-spacing: 0.5px;
  a {
    text-decoration: none;
    color: inherit;
    ${OutlineOnFocusVisible};
  }
`

const Text = styled(P)`
  font-size: 16px;
  line-height: 24px;
  color: ${colors.sand};
  margin-bottom: 0px;
  ${(props: any): string => config(props).media.lg`
    font-size: 18px;
    line-height: 27px;
  `}
`
